import * as Yup from "yup";
const dropoffValidationSchema = Yup.object({
  fullName: Yup.string()
    .matches(/^\w+( \w+)+$/, "Please enter a valid full name")
    .required("This field is required"),
  // contactNumber: Yup.number("Must be a number").required(
  //   "Please enter a contact number"
  // ),
  // email: Yup.string().email("invalid Email").required("Email is Required"),
});

export { dropoffValidationSchema };
